import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    padding: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  `,
  allAsRead: ({ theme }) => css`
    display: flex;
    background-color: ${theme.colors.neutral.variant[10]};
    color: ${theme.colors.neutral.variant[60]};
    padding: 3px 12px;
    border-radius: 12px;
    cursor: pointer;
    transition-duration: 0.1s;

    &:hover {
      background-color: ${theme.colors.neutral.variant[20]};
    }

    &:active {
      background-color: ${theme.colors.neutral.variant[30]};
    }
  `,
  allAsReadDisabled: ({ theme }) => css`
    background-color: ${theme.colors.neutral.variant[20]};
    color: ${theme.colors.neutral.variant[0]};
  `,
  filters: css`
    display: flex;
    gap: 10px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
